module.exports = __webpack_public_path__ + "fonts/Script-MT-bold.e8255879.ttf";